import { DocumentsStepContent } from "Components/Onboarding/shared/DocumentsUpload/DocumentsStepContent";
import { useCurrentUserParty } from "Hooks/useCurrentUserParty";
import { useIsCurrentUserMerchant } from "Hooks/useIsCurrentUserMerchant";

type Props = {
  onNextStepRequested: () => void;
};

export const DocumentsStep = ({ onNextStepRequested }: Props) => {
  const { data, isLoading } = useCurrentUserParty();
  const isMerchant = useIsCurrentUserMerchant();

  return (
    <DocumentsStepContent
      party={
        data?.publicID
          ? {
              publicID: data.publicID,
              hasDocumentsUploaded: !!data.hasIdentificationsUploaded,
            }
          : undefined
      }
      isLoading={isLoading}
      isSecondDocumentRequired={isMerchant}
      onNextStepRequested={onNextStepRequested}
    />
  );
};
